import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'isArray' })
export class IsArrayPipe implements PipeTransform {
  transform(value: any): boolean {
      return Array.isArray(value);
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/helpers/isArray.pipe.ts